module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA3QAAAN0BcFOiBwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAENSURBVFiF7Zc9TgNBDIU/oxTpgpJiQxp+Ko7CVejocobcIEfZo2wFoiFKAaJM9yjwLhNoxg1uxtLIcvHsJ4/9NGOSyLSL1OrArAzM7BKYB/DmPtLGk6TPKcF4BV78BTgGkm3cvwUwHXA7kig7MAeOku5rM5lZDyDpIYAZKLqcPgONQCOQTqBcQwPuzOwQwC8BgpgVPwJ2RkDAO7ALJHt03D6A2VIqpyRcDdfAMMY1B+iBPogZgPUYp89AI9AIzH7FCzN7CuBvAIKYRRmUD5Ir4JVvLai1pfuPAGYFXEs6wF8hev6nB8kkROkz0Ag0AukEyjU8AZ2vSa1tYFqtWuu8FlAIkSfK+5plWfoMfAFBepsqHwDYngAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grid.png
// module id = 243
// module chunks = 0